import * as React from 'react';
import classnames from 'classnames';

import {
  makeStyles,
  Container,
  Grid,
  Typography
} from '@material-ui/core';

import { Button } from '@hydra/common/components';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    flexWrap: 'wrap',
    paddingTop: theme.spacing(8),
    paddingBottom: theme.spacing(12)
  },
  primary: {
    color: theme.palette.common.white,
    backgroundColor: theme.palette.primary.main
  },
  success: {
    color: theme.palette.common.white,
    backgroundColor: theme.palette.success.main
  },
  title: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(4),
    fontSize: 36,
    fontWeight: theme.typography.fontWeightBold,
    lineHeight: '52px',
    textAlign: 'center'
  },
  cta: { minWidth: 150 }
}));

interface CtaBlockProps {
  title: string
  ctaLabel: string
  color?: 'primary' | 'success'
  buttonProps: {}
}

export default function CtaBlock ({
  title,
  color,
  ctaLabel,
  buttonProps
}: CtaBlockProps) {
  const classes = useStyles();

  return (
    <div className={classnames(
      classes.root,
      {
        [classes.primary]: color === 'primary',
        [classes.success]: color === 'success'
      }
    )}
    >
      <Container fixed>
        <Grid container justify='center'>
          <Grid item xs={12} md={7}>
            {
              title && (
                <Typography className={classes.title} paragraph>
                  {title}
                </Typography>
              )
            }
            {
              ctaLabel && (
                <Grid container justify='center'>
                  <Button
                    className={classes.cta}
                    {...buttonProps}
                  >
                    {ctaLabel}
                  </Button>
                </Grid>
              )
            }
          </Grid>
        </Grid>
      </Container>
    </div>
  );
}
